/**
 * MissionCard - Mission statement / pull-quote section.
 */
import React from 'react';

export interface MissionCardProps {
  variant?: string;
  eyebrow?: string;
  quote?: string;
  attribution?: string;
  title?: string;
  subtitle?: string;
  content?: string;
  className?: string;
}

const MissionCard: React.FC<MissionCardProps> = ({
  eyebrow,
  quote,
  attribution,
  title,
  subtitle,
  content,
  className = '',
}) => {
  const displayQuote = quote || content || '';
  const displayTitle = title || eyebrow;
  return (
    <div className={`content-card ${className}`} style={{ textAlign: 'center', padding: 'var(--spacing-12) var(--spacing-8)' }}>
      {displayTitle && (
        <span style={{ display: 'block', fontSize: 'var(--font-size-xs)', fontWeight: 'var(--font-weight-semibold)', letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--color-primary)', marginBottom: 'var(--spacing-6)' }}>
          {displayTitle}
        </span>
      )}
      {subtitle && <p style={{ color: 'var(--color-text-muted)', marginBottom: 'var(--spacing-4)' }}>{subtitle}</p>}
      {displayQuote && (
        <blockquote style={{ fontSize: 'clamp(1.1rem, 2vw, 1.4rem)', fontStyle: 'italic', lineHeight: 'var(--line-height-relaxed)', color: 'var(--color-text)', maxWidth: '760px', margin: '0 auto', border: 'none', padding: 0, position: 'relative' }}>
          <span aria-hidden="true" style={{ position: 'absolute', top: '-1rem', left: '-1rem', fontSize: '5rem', color: 'var(--color-primary)', opacity: 0.15, lineHeight: 1, fontFamily: 'Georgia, serif' }}>"</span>
          {displayQuote}
        </blockquote>
      )}
      {attribution && (
        <p style={{ marginTop: 'var(--spacing-6)', fontSize: 'var(--font-size-sm)', color: 'var(--color-text-muted)', fontWeight: 'var(--font-weight-semibold)' }}>
          — {attribution}
        </p>
      )}
    </div>
  );
};

export default MissionCard;
